import React, { useState, useEffect } from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/app-sidebar";
import { useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import Modal from "@/components/overlays/Modal";
import LogoPro from "/src/pages/login/img/logo-blue.svg";
import RoundButton from "@/components/forms/RoundButton";
import ReportBug from "@/components/forms/ReportBug";
import { useProfile } from "@/_actions/userActions";
import SidebarTrigger from "@/components/sidebar-trigger";
import SiteAlert from "@/components/elements/SiteAlert.jsx";

export default function Layout({ children }) {
  const { data: profile, mutate: mutateProfile } = useProfile();
  const { pathname } = useLocation();
  const [showWelcome, setShowWelcome] = useState(false);
  useEffect(() => {
    mutateProfile();
    const paths = ["/properties", "/contacts"];
    if (profile?.business_name == "" && paths.indexOf(pathname) > -1) {
      setShowWelcome(true);
    } else {
      setShowWelcome(false);
    }
  }, [profile, pathname, mutateProfile]);

  return (
    <SidebarProvider>
      <AppSidebar />
      <main className="w-full bg-[#EFF2F5]">
        <div className="m-2 fixed z-50">
          <SidebarTrigger />
        </div>
        <div className="px-2 py-2 md:px-5 md:py-3  ">
          {/* <SiteAlert
            type="warning"
            title="Mantenimiento en curso"
            description="Estamos realizando tareas de mantenimiento. Es posible que experimentes intermitencias en el servicio. Estamos trabajando para solucionarlo lo antes posible. Gracias por tu paciencia."
            dismissible
          /> */}
          <Outlet />
        </div>
      </main>

      <Modal open={showWelcome} centerFullScreen={false}>
        <div className="flex w-full flex-col items-center justify-center p-8 text-dark">
          <span className="mb-3 text-xl text-center">
            ¡Hola! Te damos la bienvenida a
          </span>
          <img src={LogoPro} alt="cyt pro logo" className="w-[230px]" />
          <span className="mt-3 text-xl text-center text-primary-default">
            Completa los datos de tu cuenta
          </span>
          <span className="text-center text-xl text-dark">
            para publicar propiedades 🏘
          </span>
          <a
            href="/profile"
            alt="profile link"
            className="mt-6 w-full max-w-[212px]"
          >
            <RoundButton active={true} text="Ir a cuenta" />
          </a>
        </div>
      </Modal>
      <ReportBug />
    </SidebarProvider>
  );
}
